import Vue from 'vue';
import moment from 'moment';
import _ from 'underscore';

export const state = {
  contract: null,
  contracts: [],
  services: [],
  tenancies: [],
  serviceBundles: [],
  serviceBundlesPrices: [],
  serviceBundleList: [],
  customerLevelPriorityServices: [],
  serviceLevelPriorityServices: [],
  gasServices: null,
  serviceToggle: null,
  elecServices: null,
  telecomServices: null,
  progress: null,
  contractIndex: [],
  serviceBundleExportSearch: null,
  serviceBundleExport: null,
  activeSection: 'Contracts',
  breadcrumbItems: ['Contracts'],
  activeContract: null,
  renewalSignedDate: null,
  renewalStartDate: null,
  renewalEndDate: null,
  renewalContractType: null,
  activeBundle: null,
  activeService: null,
  activeServiceType: null,
  activePSRSet: null,
  psrName: null,
  psrPassword: null,
  psrNotes: null,
  psrServices: [],
  editContractMode: false, // Probably doesn't need to be a Vuex prop
  editBundleMode: false, // Probably doesn't need to be a Vuex prop
  editServiceMode: false, // Probably doesn't need to be a Vuex prop
  editConfigMode: false, // Probably doesn't need to be a Vuex prop
  editPSRSetMode: false, // Probably doesn't need to be a Vuex prop
  editPriorityServiceMode: false, // Probably doesn't need to be a Vuex prop
  activeCommercialConfig: null,
  contractsMenu: [],
  hhnhhmappings: [],
};

export const mutations = {
  updateContractsMenu(state, menu) {
    state.contractsMenu = menu;
  },
  updateContracts(state, contracts) {
    state.contracts = contracts;
    state.contractIndex = [];
    for (let i = 0; i < contracts.length; i++) {
      if (!state.contract || contracts[i].EndDate > state.contract.EndDate) {
        state.contract = contracts[i];
      }
      state.contractIndex.push({
        serviceIndex: [],
        service: null,
        serviceBundle: null,
        contractPSRDate: moment.utc(moment().format('YYYY-MM-DD')).format(),
        servicePSRDate: moment.utc(moment().format('YYYY-MM-DD')).format(),
        contractPriorityService: null,
        servicePriorityService: null,
        customerLevelNotes: '',
        serviceLevelNotes: '',
        serviceBundleStart: moment.utc(moment().format('YYYY-MM-DD')).format(),
        searchId: null,
        results: null,
      });
      for (let j = 0; j < contracts[i].Services.length; j++) {
        state.contractIndex[i].serviceIndex.push({
          configurationIndex: [],
        });
        if (contracts[i].Services[j].ServiceType === 'Gas') {
          for (
            let k = 0;
            k <
            contracts[i].Services[j].GasDetails.CommercialConfigurations.length;
            k++
          ) {
            state.contractIndex[i].serviceIndex[j].configurationIndex.push({
              commercial:
                Vue.config.honeycomb.commercialConfig.commercialPercentage,
              ccaReduction:
                Vue.config.honeycomb.commercialConfig.ccaReductionPercentage,
              ccaNotes: null,
              exemptionType: 'NotExempt',
              billingAq: null,
              applicationRule: 'Always',
              commercialConfigStart: moment
                .utc(moment().format('YYYY-MM-DD'))
                .format(),
            });
          }
        } else if (contracts[i].Services[j].ServiceType === 'Electricity') {
          for (
            let k = 0;
            k <
            contracts[i].Services[j].ElectricityDetails.CommercialConfigurations
              .length;
            k++
          ) {
            state.contractIndex[i].serviceIndex[j].configurationIndex.push({
              commercial:
                Vue.config.honeycomb.commercialConfig.commercialPercentage,
              ccaReduction:
                Vue.config.honeycomb.commercialConfig.ccaReductionPercentage,
              ccaNotes: null,
              exemptionType: 'NotExempt',
              eaq: null,
              applicationRule: 'Always',
              commercialConfigStart: moment
                .utc(moment().format('YYYY-MM-DD'))
                .format(),
            });
          }
        }
      }
    }
  },
  updateMprnContracts(state, contracts) {
    state.mprnContracts = contracts;
  },
  updateIndices(state, indices) {
    state.contractIndex = indices;
  },
  updateCustomerLevelPriorityServices(state, priortityServices) {
    state.customerLevelPriorityServices = priortityServices;
  },
  updateServiceLevelPriorityServices(state, priorityServices) {
    state.serviceLevelPriorityServices = priorityServices;
  },
  updateServiceToggle(state, reading) {
    state.serviceToggle = reading;
  },
  updateServiceBundles(state, bundles) {
    state.serviceBundles.push(bundles);
  },
  updateServiceBundlesPrices(state, bundles) {
    state.serviceBundlesPrices = _.union(state.serviceBundlesPrices, bundles);
  },
  updateTenancies(state, tenancy) {
    state.tenancies.push(tenancy);
  },
  updateServiceBundleList(state, bundles) {
    state.serviceBundleList = bundles;
  },
  updateServices(state, service) {
    state.services.push(service);
  },
  updateServiceBundleExportSearch(state, search) {
    state.serviceBundleExportSearch = search;
  },
  updateServiceBundleExport(state, bundle) {
    state.serviceBundleExport = bundle;
  },
  updateActiveSection(state, section) {
    state.activeSection = section;
  },
  updateBreadcrumbItems(state, items) {
    state.breadcrumbItems = items;
  },
  addBreadcrumbItems(state, items) {
    // Note: There should probably be an error thrown here when items isn't an array
    if (Array.isArray(items)) {
      return (state.breadcrumbItems = state.breadcrumbItems.concat(items));
    }
    // Note: This is strange behavior for a mutation. Need to check what the return value is being used for.
    return state.breadcrumbItems.push(items);
  },
  updateActiveContract(state, contract) {
    state.activeContract = contract;
    state.renewalSignedDate = contract.EndDate;
    state.renewalStartDate = contract.EndDate;
    state.renewalContractType = contract.ContractType;
    state.renewalEndDate = moment(contract.EndDate).add(1, 'years');
  },
  updateRenewalSignedDate(state, date) {
    state.renewalSignedDate = date;
  },
  updateRenewalStartDate(state, date) {
    state.renewalStartDate = date;
  },
  updateRenewalEndDate(state, date) {
    state.renewalEndDate = date;
  },
  updateRenewalContractType(state, date) {
    state.renewalContractType = date;
  },
  updateActiveBundle(state, bundle) {
    state.activeBundle = bundle;
  },
  updateActiveService(state, service) {
    state.activeService = service;
  },
  updateActiveServiceType(state, serviceType) {
    state.activeServiceType = serviceType;
  },
  updateActivePSRSet(state, psrSet) {
    state.activePSRSet = psrSet;
  },
  updatePSRName(state, name) {
    state.psrName = name;
  },
  updatePSRPassword(state, password) {
    state.psrPassword = password;
  },
  updatePSRNotes(state, notes) {
    state.psrNotes = notes;
  },
  updateEditContractMode(state, flag) {
    state.editContractMode = flag;
  },
  updateEditBundleMode(state, flag) {
    state.editBundleMode = flag;
  },
  updateEditServiceMode(state, flag) {
    state.editServiceMode = flag;
  },
  updateEditPSRSetMode(state, flag) {
    state.editPSRSetMode = flag;
  },
  updateEditPriorityServiceMode(state, flag) {
    state.editPriorityServiceMode = flag;
  },
  updateEditConfigMode(state, flag) {
    state.editConfigMode = flag;
  },
  resetEditModes(state) {
    state.editContractMode = false;
    state.editBundleMode = false;
    state.editServiceMode = false;
    state.editConfigMode = false;
    state.editPSRSetMode = false;
    state.editPriorityServiceMode = false;
  },
  updateActiveCommercialConfig(state, commercialConfig) {
    state.activeCommercialConfig = commercialConfig;
  },
  updateMappings(state, mappings) {
    state.hhnhhmappings = mappings;
  },
  updateTenancy(state, tenancy) {
    state.services.forEach((service) => {
      service.Tenancies = service.Tenancies.map(
        (t) => (t.Id === tenancy.Id ? tenancy : t)
      );
    });
  },
};

export const actions = {
  getContractsByMprn({ commit }, service) {
    // Gets all contracts connected to a service  identifier, this is duplicated code.
    Vue.prototype.$http
      .get(
        'https://' +
          Vue.config.honeycomb.contractbot.domain +
          '/api/v1/contracts/byServiceIdentifier/' +
          service.Service.ServiceIdentifier,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        commit('updateMprnContracts', response.data);
        // Note: Below updates will be redundant as props will be moved into a mixin
        commit('updateMeterSerialFilter', 'All');
        commit('updateShowExcludedReadings', false);
        commit('updateShowOnlyCustomer', true);
      });
  },

  getContracts({ rootState, commit, dispatch }) {
    // Get all the contracts for a customer
    return Vue.prototype.$http
      .get(
        'https://' +
          Vue.config.honeycomb.queenbee.domain +
          '/api/v1/Contracts/?customerId=' +
          rootState.customers.customer.Id,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        commit('updateContracts', response.data);
        // dispatch('getTenancies')
        dispatch('getServiceList');
        dispatch('getServiceBundles');
        dispatch('getServiceBundlePrices');
        dispatch('getCustomerLevelPriorityServices');
      });
  },

  getServiceBundles({ commit, state }) {
    state.contracts.forEach((contract) => {
      contract.ServiceBundles.forEach((bundle) => {
        Vue.prototype.$http
          .get(
            'https://' +
              Vue.config.honeycomb.contractbot.domain +
              '/api/v1/servicebundles/' +
              bundle.ServiceBundleId,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            commit('updateServiceBundles', response.data);
          });
      });
    });
  },

  getServiceBundlePrices({ state, commit }) {
    state.serviceBundlesPrices = [];
    state.contracts.forEach((contract) => {
      contract.Services.forEach((service) => {
        Vue.prototype.$http
          .get(
            'https://' +
              Vue.config.honeycomb.queenbee.domain +
              '/api/v1/contracts/' +
              contract.Id +
              '/services/' +
              service.ServiceIdentifier +
              '/prices',
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            commit(
              'updateServiceBundlesPrices',
              response.data.map((r) => ({ contractId: contract.Id, ...r }))
            );
          });
      });
    });
  },

  getTenancies({ state, commit, dispatch }) {
    state.tenancies = [];
    state.contracts.forEach((contract) => {
      contract.Services.forEach((service) => {
        let tenancySharedId =
          service.ServiceType === 'Gas'
            ? service.GasDetails.TenancySharedId
            : service.ElectricityDetails.TenancySharedId;
        Vue.prototype.$http
          .get(
            'https://' +
              Vue.config.honeycomb.contractbot.domain +
              '/api/v1/tenancies/' +
              tenancySharedId,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            commit('updateTenancies', response.data);
            dispatch('getServiceLevelPriorityServices', response.data);
          });
      });
    });
  },

  getCustomerLevelPriorityServices({ rootState, commit }) {
    Vue.prototype.$http
      .get(
        'https://' +
          Vue.config.honeycomb.contractbot.domain +
          '/api/v1/PriorityServices/?customerId=' +
          rootState.customers.customer.Id,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        commit('updateCustomerLevelPriorityServices', response.data.Records);
      });
  },

  getServiceLevelPriorityServices({ state, commit }, tenancy) {
    state.services.forEach((service) => {
      if (service.Service.hasOwnProperty('PriorityServiceSetId')) {
        Vue.prototype.$http
          .get(
            'https://' +
              Vue.config.honeycomb.contractbot.domain +
              '/api/v1/PriorityServices/' +
              tenancy.PriorityServiceSetId,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            commit('updateServiceLevelPriorityServices', response.data);
          });
      }
    });
  },

  getBundleByReference(store, reference) {
    return Vue.prototype.$http.get(
      'https://' +
        Vue.config.honeycomb.contractbot.domain +
        '/api/v1/ServiceBundles/' +
        reference +
        '/complete',
      {
        withCredentials: true,
      }
    );
  },

  async getMappings({ commit }) {
    const mappings = await Vue.prototype.$http.get(
      'https://' +
        Vue.config.honeycomb.contractbot.domain +
        '/api/v1/hhnhhmappings',
      {
        withCredentials: true,
      }
    );
    commit(
      'updateMappings',
      mappings.data.Records.map((m) => ({
        label:
          Vue.prototype.$config.honeycomb.HHNHHMappings[m.Description] ||
          m.Description,
        value: m.Id,
        isVisible: m.IsVisible,
      }))
    );
  },
};

export default {
  state,
  mutations,
  actions,
  getters: {
    gasServices: (state) => {
      return state.contract.Services.filter(
        (service) => service.ServiceType == 'Gas'
      ).length;
    },
    elecServices: (state) => {
      return state.contract.Services.filter(
        (service) => service.ServiceType == 'Electricity'
      ).length;
    },
    telecomServices: (state) => {
      return state.contract.Services.filter(
        (service) => service.ServiceType == 'Telecom'
      ).length;
    },
    progress: (state) => {
      return (
        (moment().diff(moment(state.contract.StartDate), 'days') /
          moment(state.contract.EndDate).diff(
            moment(state.contract.StartDate),
            'days'
          )) *
        100
      );
    },
    allTenancies: (state) => state.services.flatMap((s) => s.Tenancies),
  },
};
